export const categories = [
  { slug: 'rexue', name: '热血', icon: 'ri-fire-line' },
  { slug: 'gaoxiao', name: '搞笑', icon: 'ri-emotion-laugh-line' },
  { slug: 'lianai', name: '恋爱', icon: 'ri-heart-line' },
  { slug: 'xuanyi', name: '悬疑', icon: 'ri-search-eye-line' },
  { slug: 'qihuan', name: '奇幻', icon: 'ri-magic-line' },
  { slug: 'kehuan', name: '科幻', icon: 'ri-rocket-line' },
  { slug: 'dushi', name: '都市', icon: 'ri-building-line' },
  { slug: 'gufeng', name: '古风', icon: 'ri-ancient-gate-line' },
  { slug: 'maoxian', name: '冒险', icon: 'ri-compass-line' },
  { slug: 'kongbu', name: '恐怖', icon: 'ri-ghost-line' },
];

export const statusLabels: Record<string, string> = {
  serializing: '连载中',
  completed: '已完结',
};

export interface ComicChapter {
  id: number;
  title: string;
  updateTime: string;
}

export interface Comic {
  id: number;
  title: string;
  author: string;
  coverImage: string;
  category: string;
  status: string;
  latestChapter: string;
  latestChapterId: number;
  updateTime: string;
  description: string;
  tags: string[];
  views: number;
  favorites: number;
  chapters: ComicChapter[];
  content: string;
}

export const comics: Comic[] = [
  {
    id: 1,
    title: '星辰变',
    author: '我吃西红柿',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20cover%20art%20style%20celestial%20warrior%20with%20glowing%20golden%20energy%20surrounded%20by%20stars%20and%20galaxies%20dynamic%20composition%20clean%20minimal%20background%20warm%20orange%20and%20gold%20tones%20anime%20illustration&width=400&height=560&seq=comic-cover-01&orientation=portrait',
    category: 'rexue',
    status: 'serializing',
    latestChapter: '第358话 星辰大海',
    latestChapterId: 358,
    updateTime: '2026-08-04',
    description: '少年秦羽天生无法修炼内功，为了得到父亲的重视，他毅然选择修炼艰难的外功。一场星辰之变，让他从此踏上了一条与众不同的修炼之路。',
    tags: ['修仙', '热血', '玄幻', '成长'],
    views: 12580000,
    favorites: 892000,
    chapters: [
      { id: 358, title: '第358话 星辰大海', updateTime: '2026-08-04' },
      { id: 357, title: '第357话 突破极限', updateTime: '2026-08-01' },
      { id: 356, title: '第356话 天劫降临', updateTime: '2026-07-28' },
      { id: 355, title: '第355话 星辰之力', updateTime: '2026-07-25' },
      { id: 354, title: '第354话 决战前夕', updateTime: '2026-07-22' },
    ],
    content: '<p>少年秦羽天生无法修炼内功，为了得到父亲的重视，他毅然选择修炼艰难的外功。一场星辰之变，让他从此踏上了一条与众不同的修炼之路。</p><p>在修真界中，秦羽凭借坚韧不拔的意志和独特的修炼方式，一步步突破自身极限。从最基础的外功修炼，到领悟星辰之力，再到掌控天地法则，他的成长之路充满了挑战与机遇。</p><p>最新的章节中，秦羽终于迎来了修炼路上最大的考验——天劫。面对九天神雷的轰击，他能否凭借星辰之力的庇护成功渡劫？</p>',
  },
  {
    id: 2,
    title: '绝世神医',
    author: '天蚕土豆',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20cover%20elegant%20doctor%20in%20traditional%20hanfu%20holding%20golden%20acupuncture%20needles%20with%20mystical%20green%20healing%20aura%20soft%20warm%20lighting%20clean%20background%20anime%20illustration%20style&width=400&height=560&seq=comic-cover-02&orientation=portrait',
    category: 'gufeng',
    status: 'serializing',
    latestChapter: '第216话 逆天改命',
    latestChapterId: 216,
    updateTime: '2026-08-03',
    description: '现代医学天才穿越异世成为废材，凭借精湛医术逆天改命，悬壶济世的同时揭开惊天大秘密。',
    tags: ['古风', '医术', '穿越', '逆袭'],
    views: 9820000,
    favorites: 675000,
    chapters: [
      { id: 216, title: '第216话 逆天改命', updateTime: '2026-08-03' },
      { id: 215, title: '第215话 药王谷', updateTime: '2026-07-31' },
      { id: 214, title: '第214话 以毒攻毒', updateTime: '2026-07-28' },
      { id: 213, title: '第213话 奇症', updateTime: '2026-07-25' },
      { id: 212, title: '第212话 妙手回春', updateTime: '2026-07-22' },
    ],
    content: '<p>现代医学天才叶凡在手术台上因意外身亡，灵魂穿越到了异世界一个名叫叶尘的少年身上。叶尘本是家族中最不受待见的废材，但叶凡的到来彻底改变了这一切。</p><p>凭借现代医学知识和对人体结构的深刻理解，叶尘在修炼内功心法时如鱼得水，同时他用精湛的医术救治了无数人，被誉为绝世神医。</p><p>然而，随着他一步步揭开自己的身体秘密，一个足以颠覆整个大陆的惊天大秘密逐渐浮出水面……</p>',
  },
  {
    id: 3,
    title: '龙族契约',
    author: '唐家三少',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20cover%20young%20warrior%20with%20dragon%20companion%20epic%20fantasy%20adventure%20scene%20with%20flames%20and%20magical%20runes%20orange%20and%20warm%20gold%20color%20palette%20anime%20illustration%20clean%20composition&width=400&height=560&seq=comic-cover-03&orientation=portrait',
    category: 'qihuan',
    status: 'serializing',
    latestChapter: '第189话 龙神降临',
    latestChapterId: 189,
    updateTime: '2026-08-04',
    description: '普通少年意外与远古龙族签订契约，从此踏上驯龙师之路，在龙族与人类的纷争中寻找和平之道。',
    tags: ['奇幻', '驯龙', '冒险', '契约'],
    views: 8730000,
    favorites: 598000,
    chapters: [
      { id: 189, title: '第189话 龙神降临', updateTime: '2026-08-04' },
      { id: 188, title: '第188话 龙族试炼', updateTime: '2026-08-01' },
      { id: 187, title: '第187话 契约觉醒', updateTime: '2026-07-29' },
      { id: 186, title: '第186话 龙谷危机', updateTime: '2026-07-26' },
      { id: 185, title: '第185话 初遇龙族', updateTime: '2026-07-23' },
    ],
    content: '<p>在一个人类与龙族共存的世界中，普通少年林羽意外发现了一枚远古龙蛋。当龙蛋孵化时，他与小龙建立了强大的灵魂契约，从此踏上了驯龙师的道路。</p><p>随着小龙的成长，林羽逐渐揭开了远古龙族的神秘面纱。原来，龙族并非人类想象中的怪物，它们拥有自己的文明和历史。然而，人类与龙族之间长达千年的纷争仍在继续。</p><p>林羽必须在两族之间找到平衡点，他的契约伙伴也在不断进化，即将迎来龙神降临的重要时刻……</p>',
  },
  {
    id: 4,
    title: '暗夜侦探',
    author: '墨香铜臭',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20cover%20mysterious%20detective%20in%20trench%20coat%20standing%20in%20rainy%20urban%20alley%20at%20night%20with%20magnifying%20glass%20noir%20atmosphere%20warm%20street%20lamp%20lighting%20anime%20illustration%20style&width=400&height=560&seq=comic-cover-04&orientation=portrait',
    category: 'xuanyi',
    status: 'completed',
    latestChapter: '第142话 真相大白（终）',
    latestChapterId: 142,
    updateTime: '2026-07-15',
    description: '天才侦探沈夜拥有超强的推理能力，面对一桩桩离奇案件，他用智慧与勇气还原真相，揭开隐藏在暗夜中的秘密。',
    tags: ['悬疑', '推理', '都市', '犯罪'],
    views: 15600000,
    favorites: 1023000,
    chapters: [
      { id: 142, title: '第142话 真相大白（终）', updateTime: '2026-07-15' },
      { id: 141, title: '第141话 最终推理', updateTime: '2026-07-12' },
      { id: 140, title: '第140话 幕后黑手', updateTime: '2026-07-09' },
      { id: 139, title: '第139话 关键证据', updateTime: '2026-07-06' },
      { id: 138, title: '第138话 迷雾重重', updateTime: '2026-07-03' },
    ],
    content: '<p>夜幕降临，华灯初上。在这座繁华都市的暗处，罪恶正在悄然滋生。沈夜，一位拥有超强推理能力的天才侦探，总能在最复杂的案件中找到突破口。</p><p>从连环失踪案到密室杀人，从金融诈骗到黑帮火拼，每一个案件都像一块拼图，拼凑出一个惊天大阴谋。沈夜在追查真相的过程中，也发现了自己的身世之谜。</p><p>经过142话的精彩推理，所有谜题终于水落石出。幕后黑手的身份令所有人震惊，而沈夜也在这个过程中找到了自己存在的意义。</p>',
  },
  {
    id: 5,
    title: '甜蜜契约',
    author: '顾漫',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20cover%20romantic%20couple%20under%20cherry%20blossom%20tree%20soft%20pink%20and%20warm%20peach%20tones%20elegant%20school%20uniform%20style%20sweet%20atmosphere%20anime%20illustration%20clean%20composition&width=400&height=560&seq=comic-cover-05&orientation=portrait',
    category: 'lianai',
    status: 'serializing',
    latestChapter: '第98话 心动的信号',
    latestChapterId: 98,
    updateTime: '2026-08-04',
    description: '高冷学霸与元气少女签订了一份特别的契约，从此两人的人生轨迹交织在一起，甜蜜又搞笑的校园恋爱故事。',
    tags: ['恋爱', '校园', '甜宠', '搞笑'],
    views: 6890000,
    favorites: 456000,
    chapters: [
      { id: 98, title: '第98话 心动的信号', updateTime: '2026-08-04' },
      { id: 97, title: '第97话 意外的约会', updateTime: '2026-08-01' },
      { id: 96, title: '第96话 雨中告白', updateTime: '2026-07-29' },
      { id: 95, title: '第95话 误会解除', updateTime: '2026-07-26' },
      { id: 94, title: '第94话 心跳加速', updateTime: '2026-07-23' },
    ],
    content: '<p>苏小糖是学校里出了名的元气少女，成绩平平却乐观开朗，人缘极好。而顾北辰是全校公认的高冷学霸，成绩优异却沉默寡言，独来独往。</p><p>一次偶然的机会，两人因为一份奇怪的契约绑在了一起——苏小糖需要帮顾北辰融入集体，而顾北辰则需要帮苏小糖提高成绩。原本毫无交集的两人，从此开始了打打闹闹的日常。</p><p>随着时间的推移，两人之间渐渐产生了微妙的变化。高冷学霸开始展露温柔的一面，而元气少女的心中也悄悄埋下了爱慕的种子……</p>',
  },
  {
    id: 6,
    title: '星际猎人',
    author: '辰东',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20cover%20futuristic%20space%20bounty%20hunter%20with%20high%20tech%20armor%20and%20plasma%20rifle%20standing%20on%20alien%20planet%20with%20nebula%20background%20warm%20orange%20and%20teal%20tones%20anime%20illustration&width=400&height=560&seq=comic-cover-06&orientation=portrait',
    category: 'kehuan',
    status: 'serializing',
    latestChapter: '第275话 黑洞边缘',
    latestChapterId: 275,
    updateTime: '2026-08-03',
    description: '星际时代，赏金猎人林凡接下了一个看似普通的任务，却意外卷入了一场跨星系的惊天阴谋，在宇宙深处展开冒险。',
    tags: ['科幻', '星际', '冒险', '机甲'],
    views: 11200000,
    favorites: 789000,
    chapters: [
      { id: 275, title: '第275话 黑洞边缘', updateTime: '2026-08-03' },
      { id: 274, title: '第274话 跃迁危机', updateTime: '2026-07-31' },
      { id: 273, title: '第273话 外星遗迹', updateTime: '2026-07-28' },
      { id: 272, title: '第272话 星际追捕', updateTime: '2026-07-25' },
      { id: 271, title: '第271话 暗影舰队', updateTime: '2026-07-22' },
    ],
    content: '<p>公元2457年，人类已经建立了横跨银河系的星际文明。赏金猎人凭借过人的战斗技巧和先进的机甲装备，在星际间执行各种危险任务赚取高额赏金。</p><p>林凡曾是星际联邦最精锐的特种战士，退役后成为赏金猎人。这一次，他接到了一个酬劳丰厚的任务——护送一件神秘文物前往边缘星域。然而任务途中遭遇伏击，他才发现这件文物背后隐藏着足以颠覆银河系的秘密。</p><p>在黑洞边缘，林凡必须做出选择：是继续完成任务，还是阻止那场即将到来的星际灾难？</p>',
  },
  {
    id: 7,
    title: '武林外传之剑神',
    author: '烽火戏诸侯',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20cover%20ancient%20swordsman%20in%20white%20robes%20standing%20on%20bamboo%20forest%20peak%20with%20floating%20swords%20and%20martial%20arts%20energy%20effects%20ink%20wash%20painting%20aesthetic%20anime%20illustration&width=400&height=560&seq=comic-cover-07&orientation=portrait',
    category: 'gufeng',
    status: 'serializing',
    latestChapter: '第203话 天下第一',
    latestChapterId: 203,
    updateTime: '2026-08-04',
    description: '少年剑客从山野间走出，手持一柄无名铁剑，一剑斩开江湖路，以无敌之姿问鼎武林之巅。',
    tags: ['武侠', '古风', '剑道', '江湖'],
    views: 13400000,
    favorites: 921000,
    chapters: [
      { id: 203, title: '第203话 天下第一', updateTime: '2026-08-04' },
      { id: 202, title: '第202话 剑道巅峰', updateTime: '2026-08-01' },
      { id: 201, title: '第201话 决战紫禁之巅', updateTime: '2026-07-29' },
      { id: 200, title: '第200话 万剑归宗', updateTime: '2026-07-26' },
      { id: 199, title: '第199话 剑意通神', updateTime: '2026-07-23' },
    ],
    content: '<p>在南疆一个偏僻的山村里，少年李白衣每日挥剑三千次，不知疲倦。他没有名师指点，没有绝世秘籍，只有一把师父留下的无名铁剑。</p><p>十八岁那年，师父离世前告诉他一个秘密：这柄铁剑中藏着一套失传已久的绝世剑法——太虚剑诀。从此，李白衣踏入江湖，凭借自己的努力和天赋，一步步领悟剑道真谛。</p><p>江湖险恶，人心叵测。在经历了无数次生死搏杀后，李白衣终于领悟了剑道的最高境界——无剑胜有剑。如今，他站在武林之巅，准备迎接来自天下所有高手的挑战。</p>',
  },
  {
    id: 8,
    title: '疯狂高校',
    author: '逆苍天',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20cover%20hilarious%20school%20comedy%20group%20of%20students%20laughing%20in%20classroom%20with%20exaggerated%20expressions%20bright%20warm%20colors%20fun%20atmosphere%20anime%20chibi%20style%20illustration&width=400&height=560&seq=comic-cover-08&orientation=portrait',
    category: 'gaoxiao',
    status: 'serializing',
    latestChapter: '第167话 期末考试大作战',
    latestChapterId: 167,
    updateTime: '2026-08-03',
    description: '一所奇葩高校里，一群性格各异的学生的爆笑日常。从课堂到食堂，从宿舍到操场，每一处都是欢乐的源泉。',
    tags: ['搞笑', '校园', '日常', '群像'],
    views: 7580000,
    favorites: 512000,
    chapters: [
      { id: 167, title: '第167话 期末考试大作战', updateTime: '2026-08-03' },
      { id: 166, title: '第166话 食堂争夺战', updateTime: '2026-07-31' },
      { id: 165, title: '第165话 社团招新乱斗', updateTime: '2026-07-28' },
      { id: 164, title: '第164话 宿舍夜话', updateTime: '2026-07-25' },
      { id: 163, title: '第163话 体育课大乱斗', updateTime: '2026-07-22' },
    ],
    content: '<p>欢迎来到东方高校——一所表面普通、实则奇葩云集的学校。在这里，每天都上演着各种令人捧腹的爆笑故事。</p><p>主角团六人组：爱耍帅的校草、沉迷二次元的宅男、永远在减肥的吃货、武力值爆表的班长、脑子永远缺根筋的体育生，还有那个看似普通的吐槽担当。他们的日常从不会无聊。</p><p>最新一话中，期末考试的脚步越来越近，而我们的主角团竟然还没有开始复习！一场笑料百出的临时抱佛脚大作战即将开始……</p>',
  },
  {
    id: 9,
    title: '幽灵事务所',
    author: '蝴蝶蓝',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20cover%20supernatural%20office%20setting%20with%20ghost%20characters%20and%20human%20protagonist%20mysterious%20atmosphere%20with%20ethereal%20green%20glow%20warm%20ambient%20lighting%20anime%20illustration%20style&width=400&height=560&seq=comic-cover-09&orientation=portrait',
    category: 'kongbu',
    status: 'serializing',
    latestChapter: '第89话 最后的委托',
    latestChapterId: 89,
    updateTime: '2026-08-02',
    description: '失业青年林默误入一家神秘事务所，发现这里的员工全部是幽灵！为了生计，他不得不与这群幽灵同事一起处理各种灵异委托。',
    tags: ['恐怖', '灵异', '搞笑', '都市'],
    views: 5120000,
    favorites: 345000,
    chapters: [
      { id: 89, title: '第89话 最后的委托', updateTime: '2026-08-02' },
      { id: 88, title: '第88话 地缚灵', updateTime: '2026-07-30' },
      { id: 87, title: '第87话 午夜凶铃', updateTime: '2026-07-27' },
      { id: 86, title: '第86话 镜中人', updateTime: '2026-07-24' },
      { id: 85, title: '第85话 古宅探秘', updateTime: '2026-07-21' },
    ],
    content: '<p>林默失业已经三个月了，面试了三十六家公司全部失败。就在他快要放弃的时候，一封神秘的录用通知书寄到了他手上。抱着最后一丝希望，他按照地址找到了那家名为「幽灵事务所」的公司。</p><p>推开门的瞬间，林默差点吓得魂飞魄散——公司的同事们竟然全是幽灵！但更令他惊讶的是，这些幽灵同事意外地友善，而且事务所的待遇相当不错。</p><p>就这样，林默成为了一家幽灵事务所里唯一的人类员工，每天和幽灵同事们一起处理各种超自然的委托……</p>',
  },
  {
    id: 10,
    title: '都市兵王',
    author: '小刀锋利',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20cover%20tough%20soldier%20in%20urban%20setting%20with%20city%20skyline%20background%20strong%20confident%20expression%20modern%20military%20style%20warm%20golden%20hour%20lighting%20anime%20illustration&width=400&height=560&seq=comic-cover-10&orientation=portrait',
    category: 'dushi',
    status: 'serializing',
    latestChapter: '第312话 王者归来',
    latestChapterId: 312,
    updateTime: '2026-08-04',
    description: '一代兵王回归都市，本想低调生活，却因各种原因一次次展露实力。保护身边的人，守护心中的正义，都市之中，王者无敌。',
    tags: ['都市', '兵王', '爽文', '逆袭'],
    views: 18900000,
    favorites: 1256000,
    chapters: [
      { id: 312, title: '第312话 王者归来', updateTime: '2026-08-04' },
      { id: 311, title: '第311话 龙归故里', updateTime: '2026-08-01' },
      { id: 310, title: '第310话 地下拳场', updateTime: '2026-07-29' },
      { id: 309, title: '第309话 以一敌百', updateTime: '2026-07-26' },
      { id: 308, title: '第308话 暗中守护', updateTime: '2026-07-23' },
    ],
    content: '<p>韩毅，代号「龙牙」，曾是华夏最神秘的特种部队「龙组」的王牌兵王。在一次秘密任务后，他选择退役回归都市，想过上普通人的生活。</p><p>然而，命运似乎总是不让他如愿。先是遇到了高中时代的初恋女友，然后又卷入了一场涉及地下势力的纷争。为了保护身边的人，韩毅不得不一次次展露令人震撼的实力。</p><p>都市的繁华背后，隐藏着各方势力的角逐。而韩毅，这头归来的猛虎，将在都市丛林中掀起怎样的波澜？</p>',
  },
  {
    id: 11,
    title: '秘境探险家',
    author: '南派三叔',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20cover%20adventure%20explorer%20in%20ancient%20temple%20ruins%20with%20torch%20light%20and%20mysterious%20carvings%20warm%20amber%20lighting%20atmosphere%20anime%20illustration%20style&width=400&height=560&seq=comic-cover-11&orientation=portrait',
    category: 'maoxian',
    status: 'completed',
    latestChapter: '第198话 秘境之秘（终）',
    latestChapterId: 198,
    updateTime: '2026-06-20',
    description: '考古学研究生跟随导师探索世界各地神秘秘境，每一处遗迹都隐藏着不为人知的古老秘密和惊心动魄的冒险。',
    tags: ['冒险', '考古', '秘境', '解谜'],
    views: 10400000,
    favorites: 698000,
    chapters: [
      { id: 198, title: '第198话 秘境之秘（终）', updateTime: '2026-06-20' },
      { id: 197, title: '第197话 终极谜题', updateTime: '2026-06-17' },
      { id: 196, title: '第196话 失落之城', updateTime: '2026-06-14' },
      { id: 195, title: '第195话 古人智慧', updateTime: '2026-06-11' },
      { id: 194, title: '第194话 致命机关', updateTime: '2026-06-08' },
    ],
    content: '<p>考古学研究生苏哲对古代文明怀有无限的好奇心。一次偶然的机会，他加入了导师的国际考古团队，前往世界各地的神秘遗迹进行科学考察。</p><p>从埃及金字塔深处的密室，到南美丛林中失落的玛雅神庙；从喜马拉雅山脉的雪山洞穴，到太平洋深处的海底古城。每一处秘境都隐藏着古代人类文明的惊人智慧。</p><p>经过198话的精彩探险，苏哲终于揭开了连接所有秘境的终极秘密——一个关于人类文明起源的惊天谜题。</p>',
  },
  {
    id: 12,
    title: '萌宠大作战',
    author: '会说话的肘子',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20cover%20cute%20fantasy%20creatures%20and%20pets%20surrounding%20young%20trainer%20in%20colorful%20magical%20world%20warm%20sunny%20atmosphere%20adorable%20anime%20illustration%20style&width=400&height=560&seq=comic-cover-12&orientation=portrait',
    category: 'gaoxiao',
    status: 'serializing',
    latestChapter: '第76话 进化吧！',
    latestChapterId: 76,
    updateTime: '2026-08-04',
    description: '在一个充满神奇生物的世界里，少年小智和他的萌宠伙伴们一起成长，参加宠物大赛，收集各种奇妙的生物伙伴。',
    tags: ['搞笑', '萌宠', '冒险', '收集'],
    views: 4450000,
    favorites: 298000,
    chapters: [
      { id: 76, title: '第76话 进化吧！', updateTime: '2026-08-04' },
      { id: 75, title: '第75话 宠物大赛', updateTime: '2026-08-01' },
      { id: 74, title: '第74话 神秘之蛋', updateTime: '2026-07-29' },
      { id: 73, title: '第73话 森林奇遇', updateTime: '2026-07-26' },
      { id: 72, title: '第72话 新的伙伴', updateTime: '2026-07-23' },
    ],
    content: '<p>欢迎来到萌宠世界！在这个神奇的世界里，各种各样的萌宠生物与人类和谐共处。少年小智的最大梦想就是成为一名顶尖的宠物训练大师。</p><p>从最初收服的第一只小炎龙，到如今拥有一支各具特色的萌宠队伍，小智和他的伙伴们经历了无数欢乐与挑战。每一次冒险都让他们之间的羁绊更加深厚。</p><p>最新一话中，小智的初始宠物小炎龙即将迎来关键的进化时刻。它能顺利进化成更强大的形态吗？</p>',
  },
];

export const testimonials = [
  {
    id: 1,
    name: '漫迷小明',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20boy%20avatar%20with%20warm%20smile%20simple%20background%20clean%20illustration&width=80&height=80&seq=avatar-01&orientation=squarish',
    comment: 'UU漫画是我用过最好用的追漫平台！更新提醒特别及时，再也不会错过喜欢的漫画更新了。界面也很清爽，推荐给所有漫友！',
    rating: 5,
  },
  {
    id: 2,
    name: '二次元宅女',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20girl%20avatar%20with%20pink%20hair%20simple%20background%20clean%20illustration&width=80&height=80&seq=avatar-02&orientation=squarish',
    comment: '分类做得超级详细，找漫画特别方便。而且免费漫画全集这个功能太良心了，已经推荐给身边所有姐妹了！',
    rating: 5,
  },
  {
    id: 3,
    name: '追更达人',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20young%20man%20avatar%20with%20glasses%20friendly%20expression%20simple%20background%20clean%20illustration&width=80&height=80&seq=avatar-03&orientation=squarish',
    comment: '追了三年漫画，换了好几个平台，UU漫画是我坚持最久的。更新速度快，漫画种类全，页面加载也很快，五星好评！',
    rating: 5,
  },
];

export const faqs = [
  {
    question: 'UU漫画是否需要付费？',
    answer: 'UU漫画目前所有漫画内容均为免费阅读，无需任何付费。我们致力于为漫画爱好者提供最优质的免费追更体验。',
  },
  {
    question: '如何收到漫画更新提醒？',
    answer: '您可以在喜欢的漫画详情页开启更新提醒功能。每当漫画有新章节更新时，我们会第一时间通过通知提醒您，让您不再错过任何精彩内容。',
  },
  {
    question: 'UU漫画支持哪些设备阅读？',
    answer: 'UU漫画支持电脑、平板和手机等多种设备阅读。我们的网站采用响应式设计，无论您使用什么设备，都能获得良好的阅读体验。',
  },
  {
    question: '漫画更新频率是怎样的？',
    answer: '不同漫画的更新频率不同，热门连载漫画通常每周更新1-3次。您可以在漫画详情页查看具体的更新时间和更新计划。',
  },
  {
    question: '如何搜索我想看的漫画？',
    answer: '您可以通过首页的搜索功能输入漫画名称或作者名进行搜索，也可以通过分类页面按类型浏览，快速找到感兴趣的漫画作品。',
  },
];